import React from 'react'
import './About.css'
// import pc from '../About/profilepic-modified.png'
// import { Link } from 'react-scroll'
import manvector from './man3d.png';
import Fade from 'react-reveal/Fade'


const About = () => {

  return (
    <>
      <section id="about">

        <p className='HeadP'>About Me.</p>
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" id='circle'>
          <path fill="#3333335d" d="M49.1,-70.4C63.1,-67.5,73.5,-52.9,77.5,-37.4C81.6,-21.8,79.3,-5.4,73.6,8.2C67.9,21.7,58.7,32.3,48.7,40.1C38.7,47.8,27.8,52.7,16.4,56.2C5,59.7,-6.9,61.9,-21.1,62.2C-35.4,62.5,-51.9,60.9,-57.9,51.5C-63.9,42.2,-59.4,25,-61.8,8.8C-64.2,-7.4,-73.5,-22.6,-72.1,-35.9C-70.7,-49.2,-58.5,-60.6,-44.7,-63.7C-30.8,-66.8,-15.4,-61.5,1.1,-63.2C17.6,-64.9,35.1,-73.4,49.1,-70.4Z" transform="translate(100 100)" />
        </svg>

        <div className="main-box">
          <img src={manvector} alt='manVcetor'></img>


          <div className='aboutbox'>
            <h2>Hello It's Harish.</h2>

            <Fade bottom>
              <p>A Computer Science branch student at VIT Bhopal University and a full stack developer having specialization in frontend and backend development. Dedicated to building and optimizing user-focused websites and applications. Technically proficient and analytical problem solver with calm and focused demeanor.</p>
            </Fade>

            <br></br>
            <p>
              <i class="fa-solid fa-phone"></i> +91 7999365760 <br></br>
              <i class="fa-solid fa-location-dot"></i> India, Madhya Pradesh
            </p>

          </div>


        </div>

      </section>
    </>
  )
}

export default About